import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';

export type StationIndicatorBadgeSize = 'small' | 'medium';

const BADGE_DIMENSION: Record<StationIndicatorBadgeSize, number> = {
  small: 16,
  medium: 20,
};

/** Icon font sizes that fit inside {@link StationIndicatorBadge} at each size. */
export const STATION_INDICATOR_BADGE_ICON_FONT_SIZE: Record<StationIndicatorBadgeSize, string> = {
  small: '0.75rem',
  medium: '0.875rem',
};

interface StationIndicatorBadgeProps {
  size?: StationIndicatorBadgeSize;
  className?: string;
  sx?: SxProps<Theme>;
  children: ReactNode;
}

/**
 * Circular paper badge wrapper for inline station indicators (shared, YouTube native, etc.).
 */
export function StationIndicatorBadge({
  size = 'medium',
  className,
  sx,
  children,
}: StationIndicatorBadgeProps) {
  const dimension = BADGE_DIMENSION[size];

  return (
    <Box
      className={className}
      sx={
        [
          {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            width: dimension,
            height: dimension,
            borderRadius: '50%',
            bgcolor: 'background.paper',
            boxShadow: 1,
          },
          sx,
        ] as SxProps<Theme>
      }
    >
      {children}
    </Box>
  );
}
